import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getProfileOwnerUser } from '../../../../selectors/users';

import { Props } from './FeaturedPostThumb';

type StateProps = Pick<Props, 'isAuthor'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const profileOwnerUser = getProfileOwnerUser(state);
  const deviation = ownProps.deviation;
  const isAuthor = profileOwnerUser.userId
    ? profileOwnerUser.userId === deviation.author?.userId
    : false;
  return {
    isAuthor,
  };
};

export default connect(mapStateToProps);
